// @ts-strict-ignore
/**
 * All stores that are shared throughout the app should be created here. Currently this is every store in the app,
 * but can be broken out into smaller files as smaller stand-alone React apps are extracted.
 */
import { flux } from '@/core/flux.module';
import { WorkbenchStore } from '@/workbench/workbench.store';
import { AdministrationStore } from '@/administration/administration.store';
import { PdfExportStore } from '@/reportEditor/pdfExport.store';
import { DatasourcesStore } from '@/hybrid/administration/datasources/datasources.store';
import { AssetGroupStore } from '@/hybrid/assetGroupEditor/assetGroup.store';
import { LicenseManagementStore } from '@/licenseManagement/licenseManagement.store';
import { InvestigateStore } from '@/hybrid/toolSelection/investigate.store';
import { PluginStore } from '@/hybrid/plugin/plugin.store';
import { WorkbookStore } from '@/workbook/workbook.store';
import { DurationStore } from '@/trendData/duration.store';
import { WorksheetStore } from '@/worksheet/worksheet.store';
import { HomeScreenStore } from '@/hybrid/homescreen/homescreen.store';
import { AnnotationStore } from '@/annotation/annotation.store';
import { WorkstepsStore } from '@/worksteps/worksteps.store';
import { SystemWarningStore } from '@/hybrid/systemWarning/systemWarning.store';
import { ExploreFolderModalStore } from '@/hybrid/explorer/exploreFolderModal.store';
import { TimebarStore } from '@/hybrid/trend/trendViewer/timebar.store';
import { PluginsAdminStore } from '@/administration/pluginsAdmin.store';
import { ExploreWorkbookModalStore } from '@/hybrid/explorer/exploreWorkbookModal.store';
import { AxiosStore } from '@/hybrid/requests/axios.store';
import { ModalSearchStore } from '@/search/modalSearch.store';
import { SearchStore } from '@/search/search.store';
import { ConditionWithPropertiesStore } from '@/hybrid/tools/conditionWithProperties/conditionWithProperties.store';
import { ValueSearchStore } from '@/trendData/valueSearch.store';
import { CompositeSearchStore } from '@/hybrid/tools/compositeSearch/compositeSearch.store';
import { PredictionPanelStore } from '@/hybrid/tools/prediction/predictionPanel.store';
import { ItemPropertiesStore } from '@/hybrid/tools/itemProperties/propertiesPanel.store';
import { PeriodicConditionStore } from '@/hybrid/tools/periodicCondition/periodicCondition.store';
import { ManualSignalStore } from '@/hybrid/tools/manualSignal/manualSignal.store';
import { AggregationBinStore } from '@/hybrid/tools/histogram/aggregationBin.store';
import { FftStore } from '@/hybrid/tools/frequencyAnalysis/fft.store';
import { ProfileSearchStore } from '@/hybrid/tools/profileSearch/profileSearch.store';
import { DigitalFilterStore } from '@/hybrid/tools/digitalFilter/digitalFilter.store';
import { SignalSmoothingStore } from '@/hybrid/tools/signalSmoothing/signalSmoothing.store';
import { SignalFromConditionStore } from '@/hybrid/tools/signalFromCondition/signalFromCondition.store';
import { TrendMetricStore } from '@/trendData/trendMetric.store';
import { DisplayToolStore } from '@/hybrid/tools/display/displayTool.store';
import { ReferencePanelStore } from '@/hybrid/tools/referencePanel/referencePanel.store';
import { ReportStore } from '@/reportEditor/report.store';
import { TrendTableStore } from '@/trendData/trendTable.store';
import { TrendSeriesStore } from '@/trendData/trendSeries.store';
import { TrendScalarStore } from '@/trendData/trendScalar.store';
import { ImportDatafileStore } from '@/hybrid/tools/importDatafile/importDatafile.store';
import { TrendCapsuleStore } from '@/trendData/trendCapsule.store';
import { CapsuleGroupStore } from '@/hybrid/tools/manualCondition/capsuleGroup.store';
import { CursorStore } from '@/trendData/cursor.store';
import { TreemapStore } from '@/treemap/treemap.store';
import { TrendCapsuleSetStore } from '@/trendData/trendCapsuleSet.store';
import { TrendStore } from '@/trendData/trend.store';
import { ExportExcelPanelStore } from '@/hybrid/tools/exportExcel/exportExcelPanel.store';
import { TableBuilderStore } from '@/hybrid/tableBuilder/tableBuilder.store';
import { ScatterPlotStore } from '@/scatterPlot/scatterPlot.store';
import { ExportODataPanelStore } from '@/hybrid/tools/exportOData/exportODataPanel.store';

export const sqAdministrationStore = flux.createStore(AdministrationStore);
export const sqLicenseManagementStore = flux.createStore(LicenseManagementStore);
export const sqDatasourcesStore = flux.createStore(DatasourcesStore);
export const sqAssetGroupStore = flux.createStore(AssetGroupStore);
export const sqWorkbenchStore = flux.createStore(WorkbenchStore);
export const sqPdfExportStore = flux.createStore(PdfExportStore);
export const sqInvestigateStore = flux.createStore(InvestigateStore);
export const sqPluginStore = flux.createStore(PluginStore);
export const sqWorkbookStore = flux.createStore(WorkbookStore);
export const sqDurationStore = flux.createStore(DurationStore);
export const sqHomeScreenStore = flux.createStore(HomeScreenStore);
export const sqAnnotationStore = flux.createStore(AnnotationStore);
export const sqWorkstepsStore = flux.createStore(WorkstepsStore);
export const sqTimebarStore = flux.createStore(TimebarStore);
export const sqSystemWarningStore = flux.createStore(SystemWarningStore);
export const sqExploreFolderModalStore = flux.createStore(ExploreFolderModalStore);
export const sqExploreWorkbookModalStore = flux.createStore(ExploreWorkbookModalStore);
export const sqPluginsAdminStore = flux.createStore(PluginsAdminStore);
export const sqWorksheetStore = flux.createStore(WorksheetStore);
export const sqAxiosStore = flux.createStore(AxiosStore);
export const sqModalSearchStore = flux.createStore(ModalSearchStore);
export const sqSearchStore = flux.createStore(SearchStore);
export const sqCompositeSearchStore = flux.createStore(CompositeSearchStore);
export const sqConditionWithPropertiesStore = flux.createStore(ConditionWithPropertiesStore);
export const sqValueSearchStore = flux.createStore(ValueSearchStore);
export const sqItemPropertiesStore = flux.createStore(ItemPropertiesStore);
export const sqManualSignalStore = flux.createStore(ManualSignalStore);
export const sqFftStore = flux.createStore(FftStore);
export const sqAggregationBinStore = flux.createStore(AggregationBinStore);
export const sqSignalFromConditionStore = flux.createStore(SignalFromConditionStore);
export const sqPeriodicConditionStore = flux.createStore(PeriodicConditionStore);
export const sqProfileSearchStore = flux.createStore(ProfileSearchStore);
export const sqPredictionPanelStore = flux.createStore(PredictionPanelStore);
export const sqSignalSmoothingStore = flux.createStore(SignalSmoothingStore);
export const sqDigitalFilterStore = flux.createStore(DigitalFilterStore);
export const sqTrendMetricStore = flux.createStore(TrendMetricStore);
export const sqTrendTableStore = flux.createStore(TrendTableStore);
export const sqReferencePanelStore = flux.createStore(ReferencePanelStore);
export const sqDisplayToolStore = flux.createStore(DisplayToolStore);
export const sqTrendScalarStore = flux.createStore(TrendScalarStore);
export const sqReportStore = flux.createStore(ReportStore);
export const sqTrendSeriesStore = flux.createStore(TrendSeriesStore);
export const sqImportDatafileStore = flux.createStore(ImportDatafileStore);
export const sqTrendCapsuleStore = flux.createStore(TrendCapsuleStore);
export const sqCapsuleGroupStore = flux.createStore(CapsuleGroupStore);
export const sqCursorStore = flux.createStore(CursorStore);
export const sqTrendCapsuleSetStore = flux.createStore(TrendCapsuleSetStore);
export const sqTrendStore = flux.createStore(TrendStore);
export const sqTreemapStore = flux.createStore(TreemapStore);
export const sqExportExcelPanelStore = flux.createStore(ExportExcelPanelStore);
export const sqScatterPlotStore = flux.createStore(ScatterPlotStore);
export const sqExportODataPanelStore = flux.createStore(ExportODataPanelStore);
export const sqTableBuilderStore = flux.createStore(TableBuilderStore);
